import React, { useEffect, useState } from "react";
import styled from "styled-components";
import TableComponents from "./TableComponents";
import { useTranslation } from "react-i18next";
import Pagination from "react-js-pagination";
import { Box } from "../../styled/Elements";
import { isArabic } from "../../../utils";
import { NoRecord } from "../noRecord/NoRecord";

const TableList = ({
  columns,
  rows,
  type,
  onDelete,
  options,
  idIndex,
  onView,
  onMore,
  onEdit,
  value,
  Edit,
  updateStatus,
  onViewListings,
  onClick,
  userDetailsHandler,
  activePage,
  setActivePage,
  perPage,
  totalCount,
}) => {
  const {
    t,
    i18n: { language },
  } = useTranslation();

  const [pageHrefs, setPageHrefs] = useState([]);

  const handlePageChange = (pageNumber) => {
    if (pageNumber !== activePage) {
      setActivePage(pageNumber);

      const currentUrl = window.location.href.split("?")[0];
      const newUrl = `${currentUrl}?page=${pageNumber}`;
      console.log(newUrl);

      window.history.pushState({ path: newUrl }, "", newUrl);
    }
  };

  useEffect(() => {
    const url = window.location.href.split("?")[0];
    const hrefs = Array.from(
      { length: Math.ceil(totalCount / perPage) },
      (_, index) => `${url}?page=${index + 1}`
    );
    setPageHrefs(hrefs);
  }, [totalCount, perPage]);

  return (
    <>
      <Box
        style={{ background: "transparent", height: "100%" }}
        className="table-responsive custom-scroll overflow-x-auto"
      >
        <TableStyled className="w-100 table" lang={language}>
          <thead>
            <tr>
              {columns.map((list, key) => (
                <th className="text-uppercase" key={key}>
                  {t(list.label)}
                </th>
              ))}

              {options && options.length > 0 && (
                <th className="text-uppercase" style={{ width: "150px" }}>
                  {t("actions")}
                </th>
              )}
            </tr>
          </thead>

          {rows && rows?.length > 0 ? (
            <tbody>
              {rows?.map((list, key) => (
                <tr key={key}>
                  {columns.map(({ name, render }, key) =>
                    name === "actions" ? (
                      <ActionsStyled key={key}>
                        {render ? render(list[name], list) : list[name]}
                      </ActionsStyled>
                    ) : (
                      <td
                        key={key}
                        className={`${
                          list[name] &&
                          list[name].length > 30 &&
                          "TableColumnWidth"
                        } ${
                          list[name] && isArabic(list[name])
                            ? "arabicFont"
                            : "englishFont"
                        }`}
                        // title={list[name] && list[name]}
                        // style={
                        //   (name === "phone" || name === "phone_number") &&
                        //   language === "ar"
                        //     ? { direction: "ltr", textAlign: "left" }
                        //     : {}
                        // }
                      >
                        {render
                          ? render(
                              list,
                              list[name],
                              updateStatus,
                              userDetailsHandler
                            )
                          : list[name]}
                      </td>
                    )
                  )}

                  {options && options.length > 0 && (
                    <td>
                      <TableComponents
                        updateStatus={updateStatus}
                        onDelete={onDelete}
                        type={type}
                        options={options}
                        index={idIndex}
                        Edit={Edit}
                        onMore={onMore}
                        onView={onView}
                        onViewListings={onViewListings}
                        list={list}
                        onClick={onClick}
                      />
                    </td>
                  )}
                </tr>
              ))}
            </tbody>
          ) : (
            <tbody>
              <tr>
                <td colSpan="100%">
                  <NoRecord />
                </td>
              </tr>
            </tbody>
          )}
        </TableStyled>
      </Box>
      {rows && Array.isArray(rows) && rows.length > 0 && totalCount && (
        <PaginationContainer>
          <Pagination
            itemClass="page-item"
            linkClass="page-link"
            activePage={activePage}
            itemsCountPerPage={perPage}
            totalItemsCount={totalCount}
            pageRangeDisplayed={5}
            onChange={handlePageChange}
            // getPageUrl={(pageNumber) => pageHrefs[pageNumber - 1]}
          />
        </PaginationContainer>
      )}
    </>
  );
};

export default TableList;

const TableStyled = styled.table`
  white-space: nowrap;
  background: none !important;
  border-collapse: separate;
  border-spacing: 0 4px;
  width: 100%;
  border-radius: 8px;
  overflow: hidden;
  direction: ${({ lang }) => (lang === "en" ? "ltr" : "rtl")};
  text-align: ${({ lang }) => (lang === "en" ? "left" : "right")};

  .clickable-name {
    color: #212529;
  }

  .clickable-name:hover {
    text-decoration: underline;
  }

  th {
    color: #525355;
    padding: 15px;
    /* font-family: var(--semiBold); */
    font-size: 15px;
    /* background: #e6e5e5; */
    text-align: left;
    border-bottom: 2px solid rgba(255, 255, 255, 0.2);
    direction: ${({ lang }) => (lang === "en" ? "ltr" : "rtl")};
    text-align: ${({ lang }) => (lang === "en" ? "left" : "right")};
  }

  tbody {
    tr {
      td {
        position: relative;
        color: var(--grey);
        font-size: 14px;
        padding: 15px;
        border-bottom: 1px solid rgba(200, 200, 200, 0.4);
        vertical-align: middle;
        background-color: var(--bg) !important;
        direction: ${({ lang }) => (lang === "en" ? "ltr" : "rtl")};
        font-family: ${({ lang }) =>
          lang === "ar" ? "var(--arRegular)" : "var(--regular)"};

        .tblDbMdText {
          font-family: var(--medium);
          color: var(--darkBlue);
        }
      }
      td:first-child {
        border-radius: 10px 0 0 10px;
        body.rtl & {
          border-radius: 0px 10px 10px 0px;
        }
      }
      td:last-child {
        border-radius: 0 10px 10px 0px;
        body.rtl & {
          border-radius: 10px 0 0 10px;
        }
      }

      &:last-child td {
        border-bottom: none;
      }

      &:hover {
        background-color: rgba(
          240,
          240,
          240,
          0.5
        ); /* Subtle row hover effect */
        transition: 0.2s ease-in-out;
      }
    }
  }

  tfoot {
    td {
      border-top: 2px solid rgba(200, 200, 200, 0.6);
    }
  }
`;

export const ActionsStyled = styled.div`
  display: flex;
  gap: 2px;
  cursor: pointer;
`;

export const PaginationContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 1rem;
  .page-link {
    background: var(--bgSecondary);
    color: #fff;
  }
  .page-item.active .page-link {
    background: var(--themeColorSecondary) !important;
    border-color: var(--themeColorSecondary) !important;
    margin: 0 1px;
  }
  .page-item {
    border-radius: 5px !important;
    overflow: hidden;
  }

  .page-item:last-child .page-link {
    border-top-right-radius: 5px !important;
    border-bottom-right-radius: 5px !important;
    border-top-left-radius: 5px !important;
    border-bottom-left-radius: 5px !important;
  }
  .page-item:first-child .page-link {
    border-top-right-radius: 5px !important;
    border-bottom-right-radius: 5px !important;
    border-top-left-radius: 5px !important;
    border-bottom-left-radius: 5px !important;
  }
`;
